import { initAnchorNavigation } from "modules/AnchorNavigation";

import "components/ModalForm/ModalForm";

(function (): void {
    // Initialize anchor navigation for CategoryPage
    initAnchorNavigation(".js-category-page");
})();
